import React from 'react'

function PrivacyPolicyModal({ isOpen, onClose }) {
  if (!isOpen) return null

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Privacy Policy</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p><strong>Effective Date: </strong>18/06/2025</p>
            <p>This Privacy Policy explains how we collect, use, and protect your personal data when you use our FAQ platform ("the Service"). By using the Service, you agree to the practices described below.</p>

            <h5>1. What Information We Collect</h5>
            <ul>
              <li><strong>Account Information:</strong> Email address and hashed password.</li>
              <li><strong>Usage Data:</strong> Anonymous data such as copy counts and interactions.</li>
              <li><strong>Feedback Submissions:</strong> Your email and comments are visible to company admins.</li>
              <li><strong>Uploaded Content:</strong> Admins can upload shared FAQs via CSV per company ID.</li>
              <li><strong>Pinned FAQs:</strong> We store pinned FAQs to personalize your experience.</li>
            </ul>

            <h5>2. Who Can See Your Data</h5>
            <p><strong>Admins:</strong></p>
            <ul>
              <li>Can see your email to manage account status.</li>
              <li>Can upload shared FAQs for all users under the same company account.</li>
              <li><strong>Cannot</strong> see user-created FAQs.</li>
            </ul>
            <p><strong>You (the user):</strong></p>
            <ul>
              <li>Can create and pin personal FAQs.</li>
              <li>Can see both shared and personal FAQs.</li>
            </ul>

            <h5>3. How We Use Your Data</h5>
            <ul>
              <li>To operate and improve the Service.</li>
              <li>To track FAQ engagement.</li>
              <li>To support admin account management.</li>
              <li>To respond to your feedback.</li>
            </ul>

            <h5>4. Legal Basis for Processing (GDPR)</h5>
            <p>We process data based on contractual necessity and legitimate interest. Optional analytics are anonymized or consent-based.</p>

            <h5>5. Data Retention</h5>
            <p>We retain data as long as your account is active or needed for service delivery.</p>

            <h5>6. Your Rights</h5>
            <p>You may request access, correction, deletion, or objection to processing. Contact: <strong>support@faqhelper.io</strong></p>

            <h5>7. Changes</h5>
            <p>We may update this policy and will notify users accordingly.</p>

            <h5>8. Contact</h5>
            <p>
              Thomas Andersen<br />
              Marchlewskistraße 61, 10243 Berlin, Germany<br />
              Email: support@faqhelper.io
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyModal
